import { TRootState } from "store";
import { IListEquipmentState } from "./listEquipment.types";

export const getListEquipmentSelector = (state: TRootState): IListEquipmentState => state.listEquipment;
